<template>
    <CRow
        :class="`${alignHorizontal ? `justify-content-${alignHorizontal}`: ''} ${alignVertical ? `align-items-${alignVertical}`: ''}`"
    >
        <slot />
    </CRow>
</template>

<script setup>
import { CRow } from '@coreui/vue-pro'

defineProps({
    alignHorizontal: {
        type: String,
        default: null
    },
    alignVertical: {
        type: String,
        default: null
    }
})
</script>
